import sessionStates from 'constants/session.js';

export const setOrUpdateAuthUser = payload => {
  return {
    type: sessionStates.AUTH_USER_SET_OR_UPDATE,
    payload,
  };
};

export const setOrUpdateUserAccess = payload => {
  return {
    type: sessionStates.USER_ACCESS_SET_OR_UPDATE,
    payload,
  };
};

export const setOrUpdateOrgId = payload => {
  return {
    type: sessionStates.ORG_ID_SET_OR_UPDATE,
    payload,
  };
};

export const setOrUpdateSelectedProduct = payload => {
  return {
    type: sessionStates.SELECTED_PRODUCT_SET_OR_UPDATE,
    payload,
  };
};
